import PropTypes from 'prop-types'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Colors from 'Theme/Colors'
import React, { useState, useImperativeHandle } from 'react'
import { ChargePointDetailsTab } from 'Components'
import ChargingEventsModalTabsSkeleton from './ChargingEventsModalTabsSkeleton'
import { useTranslation } from 'react-i18next'

const ChargingEventsModalTabs = React.forwardRef(
  ({ onValueChange, isLoading, initialIndex, canViewUptimeStats }, ref) => {
    const { t } = useTranslation()
    const [selectedIndex, setSelectedIndex] = useState(initialIndex)
    const handleChange = (event, newValue) => {
      setSelectedIndex(newValue)
      onValueChange(newValue)
    }

    const resetIndex = () => {
      setSelectedIndex(0)
    }

    useImperativeHandle(ref, () => ({
      resetIndex,
    }))

    const tabTitles = {
      ChargingEvents: t('ChargingEventsModal.ChargingEvents'),
      StationLogs: t('ChargingEventsModal.StationLogs'),
    }

    return (
      <div>
        {isLoading ? (
          <ChargingEventsModalTabsSkeleton
            tabsCount={Object.keys(tabTitles).length - +!canViewUptimeStats}
          />
        ) : (
          <Tabs
            value={selectedIndex}
            onChange={handleChange}
            TabIndicatorProps={{
              style: {
                backgroundColor: Colors.primary,
              },
            }}
          >
            {Object.values(tabTitles).map((title, index) =>
              title === tabTitles.Statistics ? (
                canViewUptimeStats ? (
                  <Tab
                    sx={{ padding: '0px' }}
                    key={index}
                    label={
                      <ChargePointDetailsTab
                        title={title}
                        isSelected={selectedIndex === index}
                      />
                    }
                  />
                ) : null
              ) : (
                <Tab
                  sx={{ padding: '0px' }}
                  key={index}
                  label={
                    <ChargePointDetailsTab
                      title={title}
                      isSelected={selectedIndex === index}
                    />
                  }
                />
              ),
            )}
          </Tabs>
        )}
      </div>
    )
  },
)

ChargingEventsModalTabs.propTypes = {
  onValueChange: PropTypes.func,
  isLoading: PropTypes.bool,
  initialIndex: PropTypes.number,
  canViewUptimeStats: PropTypes.bool,
}

export default ChargingEventsModalTabs
